import { render } from "./btcNotifications.vue?vue&type=template&id=82335be8&scoped=true"
import script from "./btcNotifications.vue?vue&type=script&lang=js"
export * from "./btcNotifications.vue?vue&type=script&lang=js"

import "./btcNotifications.vue?vue&type=style&index=0&id=82335be8&scoped=true&lang=scss"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82335be8"]])

export default __exports__